module.exports = __webpack_public_path__ + "img/partner2.098610f4.jpg";